$(document).ready(function(e) {
	$('ul.topMenu li a').click(function(event) {
		event.preventDefault();
		var ids = $(this).attr('href');
		 $('html, body').animate({
			scrollTop: $(ids).offset().top - 50
		}, 2000);
	});
	
	
	// $(".btn_scorall").click(function() {
	// 	$('html, body').animate({
	// 		scrollTop: $("#getOrder").offset().top - 40
	// 	}, 2000);
	// });
	
	
	$('.pck-opt').click(function(e) {
		$('.pck-opt').removeClass('active');
		$(this).addClass('active');
		$('.cut-price').show();
		$('.cut-price').html($(this).attr("data-retail"));
		$('.total-price').html($(this).attr("data-total"));
	});
	
	$('.pck-opt1').click(function(e) {
		$('.cut-price').hide();
	});
	
	
	$('.package-slide-div').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		asNavFor: '.package-slider-nav',
		autoplay: false,
		autoplaySpeed: 11000,
		dots: false,
	});

	$('.package-slider-nav').slick({
		slidesToShow:5,
		slidesToScroll: 1,
		asNavFor: '.package-slide-div',
		dots: false,
		centerMode: false,
		focusOnSelect: true,
		arrows: false,
	});
	

	
	$('.bnr-testi-row').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		fade: false,
		autoplay: false,
		dots: true,
		variableWidth: false,
		centerMode: false,
	});
	
	
	
	$('.s2-order-row').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		autoplay: true,
		dots: false,
		variableWidth: false,
		centerMode: false,
		
		responsive: [
			{
				breakpoint: 99999,
				settings:"unslick"
			},
			{
				breakpoint: 767,
				settings: {variableWidth: true,centerMode: true,}
				
			}
		]
	});

	
	//accordion JS 
	$(".acdn-heading").click(function() {
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
			if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
				});
			}
		});
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
	});
});



$(document).scroll(function() {
	if ($(this).scrollTop() > 40){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}	
});







document.addEventListener('DOMContentLoaded', function() {
    let trackingFired = false;

    function trackPageView() {
        if (!trackingFired) {
			axon("track", "view_item", {
            	"currency": "USD",
            	"items": [
					{
						"price": "69",
						"item_name": "Sleep Gummies - Melatonin-Free",
						"item_id": "8583469007086",
                        "item_variant_id": "45521653334254",
						"quantity": "1",
						"item_category_id": "469",
						"image_url": "https://cdn.shopify.com/s/files/1/0693/8119/3966/files/Sleepy_advanced.png",
					}
				]
        		});
            console.log('Page view tracked');
            trackingFired = true;
        }
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                trackPageView();
            }
        });
    }, {
        threshold: 0.05
    });

    const getOrderElement = document.getElementById('getOrder');
    if (getOrderElement) {
        observer.observe(getOrderElement);
    }

    $(".btn_scorall").click(function() {
        $('html, body').animate({
            scrollTop: $("#getOrder").offset().top - 60
        }, 2000, function() {

            trackPageView();
        });
    });

    
    if (getOrderElement && getOrderElement.getBoundingClientRect().top < window.innerHeight) {
        trackPageView();
    }
});

function createOrSyncCookies() {
	const primaryCookieName = 'axwrt';   // This is the main cookie we'll sync others to.
	const secondaryCookieName = '_axwrt'; // Axon Cookie
	let userId = getCookieValue(primaryCookieName) || getCookieValue(secondaryCookieName) || generateUserId(); // Use existing or generate new.

	// Sync both cookies - set the same userId
	setCookie(primaryCookieName, userId, 365, '/');
	setCookie(secondaryCookieName, userId, 365, '/');

	console.log('Cookies synchronized with UserId:', userId);
}

function generateUserId() {
	return 'uid_' + Math.random().toString(36).substr(2, 9);
}

function getCookieValue(cookieName) {
	var name = cookieName + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i].trim();
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return null;
}

function setCookie(name, value, days, path) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + value + expires + "; path=" + path;
}

createOrSyncCookies();